import React, { FC } from 'react'

import PageHead from '../../components/PageHead'
import PageNotFoundMessage from '../../components/PageNotFoundMessage'

const PageNotFound: FC = () => <PageNotFoundMessage />

export default PageNotFound

export const Head = ({ location }: { location: { pathname: string } }) => (
  <PageHead title="404 Page not found" location={location} />
)
